import { render } from "./RaSection.vue?vue&type=template&id=57e415e8&scoped=true"
import script from "./RaSection.vue?vue&type=script&lang=js"
export * from "./RaSection.vue?vue&type=script&lang=js"

import "./RaSection.vue?vue&type=style&index=0&id=57e415e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e415e8"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QPopupEdit from 'quasar/src/components/popup-edit/QPopupEdit.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QCard,QCardSection,QIcon,QTooltip,QBtn,QSeparator,QList,QItem,QPopupEdit,QSelect,QItemSection,QCheckbox,QItemLabel,QBadge,QDialog,QTabs,QTab,QTabPanels,QTabPanel,QCardActions,QAvatar});qInstall(script, 'directives', {ClosePopup});
